export const ToastMessage = {
  UPDATED_SUCCESS: 'Updated successfully!',
  UPDATED_FAIL: 'Updated Fail!',
  ADD_SUCCESS: 'Added successfully!',
  ADD_FAIL: 'Added Fail!',
  SERVER_ERROR: 'Something went wrong!',
  DELETED_SUCCESS: 'Deleted successfully!',
  DELETED_FAIL: 'Deleted Fail!',
  FETCH_FAIL: 'Failed to fetch data!',
};
